'use strict';

  /**
   * https://github.com/kvz/phpjs/blob/master/functions/url/urlencode.js
   * @param url
   * @return {string} encoded url
   */
module.exports.urlencode = function (str) {
	str = (str + '').toString();
	// Tilde should be allowed unescaped in future versions of PHP (as reflected below), but if you want to reflect current
	// PHP behavior, you would need to add '.replace(/~/g, '%7E');' to the following.
	return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
}
